import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';
import { LmsContentEditorComponent } from '../../lms-layout/lms-content-editor/lms-content-editor.component';
import swal from 'sweetalert2';

@Component({
  selector: 'app-lms-new-content',
  templateUrl: './lms-new-content.component.html',
  styleUrls: ['./lms-new-content.component.scss']
})
export class LmsNewContentComponent implements OnInit {

  selectedItem = 'All'
  searchValue: ''
  s3MediaUrl = environment?.apiUrls?.s3MediaUrl
  @Input() courseId: any
  @Input() topicId: any 
  @Input() isReadMode: any 
  apps: any[] = []
  @Input() topics:any = []
  isLoading: boolean = false;
  @Input() appsByTopic: any[] = []
  @Output() refreshData = new EventEmitter<any>();
  isAppBtns: boolean = false
  appType: any;
  @ViewChild('modalRef') modal: LmsContentEditorComponent;
  sanitizedUrl: SafeHtml;
  sanitizedContent: SafeHtml;
  selectedApp: any;
  user:any
  assignment_model={
    student_id: '',
    course_id: '',
    topic_id: '',
    app_id: '',
    title: '',
    notes: '',
    admin_notes: ''
  }
  isSubmitted :any
  constructor(private router: Router,
    private toast: ToastrService,
    private _sanitizer: DomSanitizer,
    private apiService: ApiService,private modalService: NgbModal,) { 
      this.user =JSON.parse(localStorage.getItem('user'))
    }
  ngOnInit(): void {
    // this.apps = [...this.appsByTopic]
    // console.log('apps', this.apps)
    // console.log('topics', this.topics)
    setTimeout(() => {
      this.isLoading = false;
    }, 3000);
  }
  ngOnChanges() {
    this.isLoading = true;
    this.apps = [...this.appsByTopic]
    if(this.user.id && this.topicId && this.apps[0]?._id){
      this.checkAssignmentIsSubmit(this.user.id,this.topicId,this.apps[0]?._id)
    }

    // console.log('apps', this.apps)
    // console.log('topics', this.topics)
    setTimeout(() => {
      this.isLoading = false;
    }, 3000);  }
  closeModel(): void {
    this.refreshData.emit()
  }
  safeUrl(videoURL) {
    videoURL = videoURL.replace(/width="[^"]+"/, 'width="100%"');
    this.sanitizedUrl = this._sanitizer.bypassSecurityTrustHtml(videoURL);
  }
  formatHtml(videoURL) {
    return JSON.parse(videoURL);
  }
  searchApp(value) {
    if (value) {
      this.isLoading = true;
      this.apiService.searchApp(1, 100, this.selectedItem, value).subscribe((res: any) => {
        if (res?.isSuccess) { this.searchValue = "", this.apps = res?.data?.items
        this.isLoading = false;
            }
        else {
          this.toast.error(res?.error)
          this.isLoading = false;
        }
      })
    }
    else {
      this.apps = [...this.appsByTopic]
      this.isLoading = false;
    }

  }
  addApp(app) {
    this.appType = app

    // const queryParams = {
    //   app: app,
    //   courseId: this.courseId,
    //   topicId: this.appsByTopic?.length ? null : this.topicId
    // };
    // this.router.navigate([`/edit-content`], { queryParams })
  }
  connectDisconnect(appId) {

    let model = {
      appId: appId,
      topicId: this.topicId
    }
    let path = this.isConnected(appId) ? 'removeApp' : 'addApps'
    swal.fire({
      title: 'Are you sure?',
      text: `You won't be able to ${this.isConnected(appId) ? 'Disconnect' : 'Connect'} app!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2F8BE6',
      cancelButtonColor: '#F55252',
      confirmButtonText: `Yes, ${this.isConnected(appId) ? 'Disconnect' : 'Connect'} it!`,
      customClass: {
        confirmButton: 'btn btn-warning',
        cancelButton: 'btn btn-danger ml-1'
      },
      buttonsStyling: false,
    }).then((result) => {
      if (result.value) {
        this.apiService.attachOrRemoveApp(path, model).subscribe((res: any) => {
          if (res?.isSuccess) {
            swal.fire({
              icon: "success",
              title: `${this.isConnected(appId) ? 'Disconnect' : 'Connect'}`,
              text: `${res.message}`,
              customClass: {
                confirmButton: 'btn btn-success'
              },
            })
            this.refreshData.emit()
          }
          else {
            swal.fire({
              title: 'Error',
              text: `${res.error}`,
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-success'
              },
            })
          }
        })
      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });


  }
  isConnected(appId) {
    return this.appsByTopic.some((item) => item._id == appId)
  }
  editApp(app) {
    this.selectedApp = app
  }

  items: string[] = ['Option 1', 'Option 2', 'Option 3'];
  searchTerm: string;


  get filteredItems$(): string[] {
    return this.searchTerm ? this.filterItems(this.searchTerm) : [];
  }

  filterItems(value: string): string[] {
    return this.topics.filter(item =>
      item.name.toLowerCase().includes(value.toLowerCase())
    );
  }

  selectItem(item: string): void {
    this.searchTerm = item;
  }
  resourceDelete(app_id,resource_id){
    // console.log('app_id',app_id,'resource_id',resource_id)
    let body={
      resource: resource_id,
      app: app_id
    }
  
    swal.fire({
      title: 'Are you sure?',
      text: `You won't be able to delete!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2F8BE6',
      cancelButtonColor: '#F55252',
      confirmButtonText: `Yes, delete it!`,
      customClass: {
        confirmButton: 'btn btn-warning',
        cancelButton: 'btn btn-danger ml-1'
      },
      buttonsStyling: false,
    }).then((result) => {
      if (result.value) {
        this.apiService.attachOrRemoveResourceApp(body).subscribe((res:any)=>{
          if(res.statusCode === 200){
            this.toast.success('Delete resource successfully ')
            this.refreshData.emit()
    
          }
          else{
            this.toast.error(res.error)
          }
        })
      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }
  openModalForAssignment(content,userId,appId,courseId,topicId) {
    this.assignment_model.student_id = userId
    this.assignment_model.app_id = appId
    this.assignment_model.course_id = courseId
    this.assignment_model.topic_id = topicId
    const options: NgbModalOptions = {
      size: 'md', // set the size of the modal
      backdrop: 'static', // set whether clicking outside the modal closes it
      centered: true // set whether the modal is centered vertically
    };
    
    const modalRef = this.modalService.open(content,options);

    modalRef.result.then((result) => {
    });
   
  }
  assignmentSubmit(){
    this.apiService.createAssignment(this.assignment_model).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        this.toast.success("Assignment submit successfull!")
        this.modalService.dismissAll()
        this.checkAssignmentIsSubmit(this.user.id,this.topicId,this.apps[0]?._id)
      }
      else this.toast.error(res?.error)
    })
  }
  checkAssignmentIsSubmit(userId,topicId,appId){
    this.apiService.checkAssignmentSubmitByStudent(userId,topicId,appId).subscribe((res:any)=>{
      this.isSubmitted = res?.data
    })
  }
}


